// extracted by mini-css-extract-plugin
export var formContainer = "_kc-0";
export var message = "_kc-1";